import Relay from 'react-relay';

const notId = (b) => Object.keys(b).filter((prop) => prop !== 'id' ).reduce((mem, prop) => ({ ...mem, [prop]: b[prop] }), {})


/**
*  Update sportunity mutation
*/
export default class UpdateSportunityMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      updateSportunity
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      sportunity: {
        ...notId(this.props.sportunity),
        modifyRepeatedSportunities: this.props.modifyRepeatedSportunities,
      },
      sportunityID: this.props.sportunity.id,
      notify_people: this.props.notify_people,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateSportunityPayload @relay(pattern: true){
        viewer {
          sportunities
        }
        edge{
          node
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        viewer: this.props.viewer.id,
        edge :{
          node : this.props.sportunity.id,
        }
      },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}



// WEBPACK FOOTER //
// ./src/mutations/Sportunity/UpdateSportunityMutation.js